import {
  GET_LEADERBOARD_SCORES_REQUEST,
  GET_LEADERBOARD_SCORES_SUCCESS,
  GET_LEADERBOARD_SCORES_FAILURE,

  GET_LEADERBOARD_SCORES_LIST_REQUEST,
  GET_LEADERBOARD_SCORES_LIST_SUCCESS,
  GET_LEADERBOARD_SCORES_LIST_FAILURE,

  GET_LEADERBOARD_RESET_SORTING,
  RESET_TRIBUN_SCORES
} from 'Store/constants';

const initialState = {
  scores: {},
  isLoading: true,
  error: null,
  leaderboardResponse: [],
  lastPage: false
};

export default (state = initialState, action ) => {
  switch (action.type) {
    case GET_LEADERBOARD_SCORES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case GET_LEADERBOARD_SCORES_SUCCESS:
      return {
        ...state,
        scores: { ...action.payload },
        isLoading: false,
        error: null
      };
    case GET_LEADERBOARD_SCORES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case GET_LEADERBOARD_SCORES_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case GET_LEADERBOARD_SCORES_LIST_SUCCESS:
      return {
        ...state,
        leaderboardResponse: action.payload.leaderboardResponse.page === 0
          ? action.payload.leaderboardResponse.scores
          : [...state.leaderboardResponse, ...action.payload.leaderboardResponse.scores],
        meResponse: action.payload.me,
        lastPage: action.lastPage,
        timeStamp: action.payload.leaderboardResponse.timeStamp,
        isLoading: false,
        error: null
      };
    case GET_LEADERBOARD_SCORES_LIST_FAILURE:
      return {
        ...state,
        lastPage: action.lastPage,
        isLoading: false,
        error: action.payload
      };

    case GET_LEADERBOARD_RESET_SORTING:
      return { ...initialState };

    case RESET_TRIBUN_SCORES:
      return { ...initialState, lastPage: true };

    default:
      return state;
  }
};
